let notifyFunction;

export const setNotifyFunction = (fn) => {
    notifyFunction = fn;
};

export const notify = (message, severity = "error") => {
    if (notifyFunction) notifyFunction(message, severity);
};
